export default __webpack_public_path__ + "static/media/Metropolis-ExtraBold.f179dd5f.otf";